import React from 'react';
import styles from './player-controls-scrubber.module.scss';

interface Props {
  liveProgressPercentage: number;
}

export const PlayerControlsScrubberStartOverLiveLimit: React.FC<Props> = (props: Props) => {
  const { liveProgressPercentage } = props;
  return (
    <div
      className={styles['player-controls-scrubber-start-over-live-limit']}
      style={{ left: `${liveProgressPercentage}%`, width: `${100 - liveProgressPercentage}%` }}
    />
  );
};

export default React.memo(PlayerControlsScrubberStartOverLiveLimit);
